<div pias-layout-content>
  @if (setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br />
  <div class="content">
    <div class="individual-container">
      <div class="page-header">
        <h5 class="page-title">APPLICATION FORM FOR NEW INTRODUCER (INDIVIDUAL)</h5>
        <mat-accordion [formGroup]="formGroup">

          <!-- Introducer's Particulars -->
          <mat-expansion-panel [expanded]="isPanelExpanded(0)" (opened)="onPanelOpened(0)" (closed)="onPanelClosed(0)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">person</mat-icon>
                Introducer's Particulars
              </mat-panel-title>
              <!-- NEW -->
              @if (sectionStatuses()['introducer'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['introducer'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="row g-3">
              <!-- Full Name -->
              <div class="col-md-6">
                <mat-label class="field-label">Name as in NRIC / Passport</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="fullName" placeholder="Enter Name as in NRIC" required />
                  @if (
                  this.formGroup.controls['fullName'].invalid &&
                  (this.formGroup.controls['fullName'].touched ||
                  this.formGroup.controls['fullName'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['fullName'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Preferred Name -->
              <div class="col-md-6">
                <mat-label class="field-label">Preferred Name (Optional)</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="preferredName" placeholder="Enter Preferred Name " />
                </mat-form-field>
              </div>

              <!-- NRIC -->
              <div class="col-md-6">
                <mat-label class="field-label">NRIC / Passport No. </mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="nric" placeholder="Enter NRIC / Passport No."
                    [required]="this.nricrequired()" />
                  @if (
                  this.formGroup.controls['nric'].invalid &&
                  (this.formGroup.controls['nric'].touched || this.formGroup.controls['nric'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['nric'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- NRIC Attachment -->
              <div class="col-md-6">
                <mat-label class="field-label">Attachment (NRIC / Passport)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" id="nricattachmentfileName"
                      (change)="onAttachmentFileChange($event, 'nricattachmentfileName', 'attachment_nric','Attachment (NRIC / Passport)')"
                      [required]="nricrequired()" [disabled]="isReadOnly()" />

                    @if (!this.formGroup.get('nricattachmentfileName')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('nricattachmentfileName')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_nric')?.value.name }}
                    </span>
                    @if(isReadOnly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="removeFile('nricattachmentfileName', 'attachment_nric','Attachment (NRIC / Passport)')">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                    (click)="previewAttachment('nricattachmentfileName','Attachment (NRIC / Passport)')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['nricattachmentfileName'].invalid &&
                (this.formGroup.controls['nricattachmentfileName'].touched ||
                this.formGroup.controls['nricattachmentfileName'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['nricattachmentfileName'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['nricattachmentfileName'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['nricattachmentfileName'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              <!-- Gender -->
              <div class="col-md-6">
                <mat-label class="field-label">Gender</mat-label>
                <mat-radio-group formControlName="gender" class="d-flex gap-3 mt-2" required>
                  <mat-radio-button value="male">Male</mat-radio-button>
                  <mat-radio-button value="female">Female</mat-radio-button>
                </mat-radio-group>
                @if (
                this.formGroup.controls['gender'].invalid &&
                (this.formGroup.controls['gender'].touched ||
                this.formGroup.controls['gender'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['gender'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              <!-- DOB -->
              <div class="col-md-6">
                <mat-label class="field-label">Date Of Birth</mat-label>
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="picker" formControlName="dob" placeholder="DD/MM/YYYY" required />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  @if (
                  this.formGroup.controls['dob'].invalid &&
                  (this.formGroup.controls['dob'].touched || this.formGroup.controls['dob'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['dob'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <!-- Nationality Section -->
            <div class="section-card mt-4">
              <h3 class="field-label">
                <mat-icon>flag</mat-icon>
                Nationality
              </h3>

              <mat-radio-group formControlName="nationality" class="d-flex flex-wrap gap-3 mb-3" required>
                <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
                <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
                <mat-radio-button value="others">Others</mat-radio-button>
              </mat-radio-group>
              @if (
              this.formGroup.controls['nationality'].invalid &&
              (this.formGroup.controls['nationality'].touched ||
              this.formGroup.controls['nationality'].dirty)
              ) {
              <mat-error>
                @if (this.formGroup.controls['nationality'].errors?.['required']) {
                <span>{{ message }}</span>
                } @else {
                <span></span>
                }
              </mat-error>
              }

              @if (
              this.formGroup.get('nationality')?.value === 'Singapore Permanent Resident' ||
              this.formGroup.get('nationality')?.value === 'others'
              ) {
              <p class="note">For Singapore Permanent Resident & Others, please state:</p>
              }
              <div class="row g-3">
                <!-- <div class="col-md-6">
                <mat-label class="field-label">Nationality</mat-label>
                <mat-form-field class="w-100">
                  <mat-select formControlName="otherNationality" placeholder="Select Nationality"
                    [required]="this.formGroup.get('nationality')?.value !== 'Singapore Citizen'" [disabled]="isReadOnly()">
                    @for(nationality of this.nationalities; track nationality) {
                    <mat-option value="{{nationality.value}}">{{nationality.name}}</mat-option>
                    }
                  </mat-select>
                  @if (
                  this.formGroup.controls['otherNationality'].invalid &&
                  (this.formGroup.controls['otherNationality'].touched ||
                  this.formGroup.controls['otherNationality'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['otherNationality'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div> -->
                <div class="col-md-6">
                  <mat-label class="field-label">Nationality</mat-label>
                  <mat-form-field class="w-100">
                    <mat-select formControlName="otherNationality" placeholder="Select Nationality"
                      [required]="this.formGroup.get('nationality')?.value !== 'Singapore Citizen'"
                      [disabled]="isReadOnly() || this.formGroup.get('nationality')?.value === 'Singapore Citizen'">
                      @for(nationality of this.nationalities; track nationality) {
                      <mat-option [value]="nationality.value">{{nationality.name}}</mat-option>
                      }
                    </mat-select>
                    @if (
                    this.formGroup.controls['otherNationality'].invalid &&
                    (this.formGroup.controls['otherNationality'].touched ||
                    this.formGroup.controls['otherNationality'].dirty)
                    ) {
                    <mat-error>
                      @if (this.formGroup.controls['otherNationality'].errors?.['required']) {
                      <span>{{ message }}</span>
                      } @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row g-3">
              <!-- Address -->
              <div class="col-md-6">
                <mat-label class="field-label">Residential Address as in NRIC / Passport:</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="address" placeholder="Enter Residential Address as in NRIC"
                    required />
                  @if (
                  this.formGroup.controls['address'].invalid &&
                  (this.formGroup.controls['address'].touched ||
                  this.formGroup.controls['address'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['address'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Address Proof Attachment -->
              <div class="col-md-6">
                <mat-label class="field-label">Attachment (Address Proof)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" id="address_proof_attachmentfileName"
                      (change)="onAttachmentFileChange($event, 'address_proof_attachmentfileName', 'address_proof_attachment','Attachment (Address Proof)')"
                      [required]="this.formGroup.get('nationality')?.value === 'others'" [disabled]="isReadOnly()" />
                    @if (!this.formGroup.get('address_proof_attachmentfileName')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('address_proof_attachmentfileName')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('address_proof_attachment')?.value.name }}
                    </span>
                    @if(isReadOnly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="removeFile('address_proof_attachmentfileName', 'address_proof_attachment','Attachment (Address Proof)')">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                    (click)="previewAttachment('address_proof_attachmentfileName','Attachment (Address Proof)')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['address_proof_attachmentfileName'].invalid &&
                (this.formGroup.controls['address_proof_attachmentfileName'].touched ||
                this.formGroup.controls['address_proof_attachmentfileName'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['address_proof_attachmentfileName'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['address_proof_attachmentfileName'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['address_proof_attachmentfileName'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              <!-- Contact Number -->
              <h5>Contact Number</h5>
              <div class="col-md-6">
                <mat-label class="field-label">Home</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="homenumber" placeholder="Enter Home Number" maxlength="13"
                    inputmode="numeric" (keypress)="allowNumbersOnly($event)"
                    (input)="sanitizeNumericInput($event, 'homenumber')" [required]="this.nricrequired()" />
                  @if (
                  this.formGroup.controls['homenumber'].invalid &&
                  (this.formGroup.controls['homenumber'].touched ||
                  this.formGroup.controls['homenumber'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['homenumber'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['homenumber'].errors?.['pattern'] ||
                    this.formGroup.controls['homenumber'].errors?.['maxlength']) {
                    <span>Only numbers are allowed, maximum 13 digits</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Mobile</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="mobilenumber" placeholder="Enter Mobile Number" maxlength="13"
                    inputmode="numeric" (keypress)="allowNumbersOnly($event)"
                    (input)="sanitizeNumericInput($event, 'mobilenumber')" [required]="this.nricrequired()" />
                  @if (
                  this.formGroup.controls['mobilenumber'].invalid &&
                  (this.formGroup.controls['mobilenumber'].touched ||
                  this.formGroup.controls['mobilenumber'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['mobilenumber'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['mobilenumber'].errors?.['pattern'] ||
                    this.formGroup.controls['mobilenumber'].errors?.['maxlength']) {
                    <span>Only numbers are allowed, maximum 13 digits</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Email -->
              <div class="col-md-6">
                <mat-label class="field-label">Email</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="email" placeholder="Enter Email" required />
                  @if (
                  this.formGroup.controls['email'].invalid &&
                  (this.formGroup.controls['email'].touched ||
                  this.formGroup.controls['email'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['email'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['email'].errors?.['email']) {
                    <span>Please enter a valid email address</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn" (click)="onSectionSave('introducer')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Employment Details -->
          <mat-expansion-panel [expanded]="isPanelExpanded(1)" (opened)="onPanelOpened(1)" (closed)="onPanelClosed(1)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">work</mat-icon>
                Employment Details
              </mat-panel-title>
              @if (getSectionStatus('employment') === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (getSectionStatus('employment') === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>
            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Current Occupation</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="occupation" placeholder="Enter Current Occupation" required />
                  @if (
                  this.formGroup.controls['occupation'].invalid &&
                  (this.formGroup.controls['occupation'].touched ||
                  this.formGroup.controls['occupation'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['occupation'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Designation</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="designation" placeholder="Enter Designation" />
                  @if (
                  this.formGroup.controls['designation'].invalid &&
                  (this.formGroup.controls['designation'].touched ||
                  this.formGroup.controls['designation'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['designation'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Name of Current Employer</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="currentEmployer" placeholder="Enter Name of Current Employer" />
                  @if (
                  this.formGroup.controls['currentEmployer'].invalid &&
                  (this.formGroup.controls['currentEmployer'].touched ||
                  this.formGroup.controls['currentEmployer'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['currentEmployer'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Employer's Address</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="employerAddress" placeholder="Enter Employer's Address" />
                  @if (
                  this.formGroup.controls['employerAddress'].invalid &&
                  (this.formGroup.controls['employerAddress'].touched ||
                  this.formGroup.controls['employerAddress'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['employerAddress'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Employer's Nature of Business</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="buisness" placeholder="Enter Employer's Nature of Business" />
                  @if (
                  this.formGroup.controls['buisness'].invalid &&
                  (this.formGroup.controls['buisness'].touched ||
                  this.formGroup.controls['buisness'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['buisness'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Employment Attachment -->
              <div class="col-md-6">
                <mat-label class="field-label">Attachment (Proof of employment)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" id="employeeattachment"
                      (change)="onAttachmentFileChange($event, 'employeeattachment', 'attachment_employee','Attachment (Proof of employment)')"
                      [required]="nricrequired()" [disabled]="isReadOnly()" />
                    @if (!this.formGroup.get('employeeattachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('employeeattachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_employee')?.value.name }}
                    </span>
                    @if(isReadOnly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="removeFile('employeeattachment', 'attachment_employee','Attachment (Proof of employment)')">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                    (click)="previewAttachment('employeeattachment','Attachment (Proof of employment)')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['employeeattachment'].invalid &&
                (this.formGroup.controls['employeeattachment'].touched ||
                this.formGroup.controls['employeeattachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['employeeattachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['employeeattachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['employeeattachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }

                <p class="note">e.g. Latest 6 months CPF Contributions statement or latest 3 months payslips, or latest
                  1
                  month employment acknowledgment letter (signed & stamped) from employer.</p>
              </div>
              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">

                <button type="button" class="save-btn" (click)="onSectionSave('employment')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Payment Details -->
          <mat-expansion-panel [expanded]="isPanelExpanded(2)" (opened)="onPanelOpened(2)" (closed)="onPanelClosed(2)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">payment</mat-icon>
                Payment Details
              </mat-panel-title>
              @if (getSectionStatus('payment') === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (getSectionStatus('payment') === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>
            <p class="note">
              Please state your personal Bank Account details for Direct Crediting of Commission to be
              earned from the introducing activity/ies. (POSB/DBS account is preferred)
            </p>
            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Name of Payee</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="payee" placeholder="Enter Name of Payee" required />
                  @if (
                  this.formGroup.controls['payee'].invalid &&
                  (this.formGroup.controls['payee'].touched ||
                  this.formGroup.controls['payee'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['payee'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Account Number</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="acNo" placeholder="Enter Account Number" />
                  @if (
                  this.formGroup.controls['acNo'].invalid &&
                  (this.formGroup.controls['acNo'].touched || this.formGroup.controls['acNo'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['acNo'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Name of Bank</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="bankName" placeholder="Enter Name of Bank" />
                  @if (
                  this.formGroup.controls['bankName'].invalid &&
                  (this.formGroup.controls['bankName'].touched ||
                  this.formGroup.controls['bankName'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['bankName'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Branch Code</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="branchCode" placeholder="Enter Branch Code" />
                  @if (
                  this.formGroup.controls['branchCode'].invalid &&
                  (this.formGroup.controls['branchCode'].touched ||
                  this.formGroup.controls['branchCode'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['branchCode'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Payment Attachment -->
              <div class="col-md-6">
                <mat-label class="field-label">Attachment (Bank Account Statement within last 3 months)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" id="paymentattachment"
                      (change)="onAttachmentFileChange($event, 'paymentattachment', 'payment_attachmentFile', 'Attachment (Bank Account Statement within last 3 months)')"
                      [required]="nricrequired()" [disabled]="isReadOnly()" />

                    @if (!this.formGroup.get('paymentattachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('paymentattachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('payment_attachmentFile')?.value.name }}
                    </span>
                    @if(isReadOnly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="removeFile('paymentattachment', 'payment_attachmentFile','Attachment (Bank Account Statement within last 3 months)')">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                    (click)="previewAttachment('paymentattachment','Attachment (Bank Account Statement within last 3 months)')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['paymentattachment'].invalid &&
                (this.formGroup.controls['paymentattachment'].touched ||
                this.formGroup.controls['paymentattachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['paymentattachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['paymentattachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['paymentattachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>
              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn" (click)="onSectionSave('payment')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- General Information -->
          <mat-expansion-panel [expanded]="isPanelExpanded(3)" (opened)="onPanelOpened(3)" (closed)="onPanelClosed(3)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                General Information
              </mat-panel-title>
              @if (getSectionStatus('general') === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (getSectionStatus('general') === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>
            <div class="check-list">
              <ol class="custom-list">

                <!-- Q1 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you ever carry out introducing activities in the past or is currently
                        carrying out introducing activities?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_1')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true, 'introducerQuestionnaires_1', 1)"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_1')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false, 'introducerQuestionnaires_1', 1)"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_1')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_1')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, which company/ies have you engaged with?</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_1"
                          placeholder="Enter schemes or company" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_1"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_1"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_1"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q2 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is carrying out introducing activities your full-time occupation? </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_2')?.value === true"
                        (change)="onCheckboxChange($event.checked, true, 'introducerQuestionnaires_2')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_2')?.value === false"
                        (change)="onCheckboxChange($event.checked, false, 'introducerQuestionnaires_2')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_2')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <!-- Q3 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Will you be based overseas? </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_3')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_3',3)"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_3')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_3',3)"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_3')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_3')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, please state the country</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_3" placeholder="Enter country" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_3"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_3"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_3"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q4 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you ever executed a deed poll, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_4')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true, 'introducerQuestionnaires_4', 4)"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_4')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false, 'introducerQuestionnaires_4', 4)"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_4')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_4')?.value === true) {
                    <div class="col-md-6">
                      <div class="col-md-10">
                        <mat-label class="field-label">(If yes, please provide a copy of the deed poll)</mat-label>

                        <div class="upload-container">
                          <div class="upload-box">
                            <input type="file" id="introducerQuestionnairesfile_4"
                              (change)="onAttachmentFileChange($event, 'introducerQuestionnairesfile_4', 'gendralinformation_introducer_Questionnaires_file_4','gendralinformation_introducer_Questionnaires_file_4')"
                              [required]="nricrequired()" [disabled]="isReadOnly()" />
                            @if (!this.formGroup.get('introducerQuestionnairesfile_4')?.value) {
                            <span> Choose file </span>
                            }
                            @if (this.formGroup.get('introducerQuestionnairesfile_4')?.value) {
                            <span class="file-name">
                              {{
                              this.formGroup.get('gendralinformation_introducer_Questionnaires_file_4')?.value.name
                              }}
                            </span>
                            @if(isReadOnly() === false){
                            <button mat-icon-button color="primary" class="delete-btn"
                             (click)="removeFile('introducerQuestionnairesfile_4', 'gendralinformation_introducer_Questionnaires_file_4','gendralinformation_introducer_Questionnaires_file_4')">
                            <mat-icon>close</mat-icon>
                            </button>
                            }
                           <button mat-icon-button color="primary" class="delete-btn"
                            (click)="previewAttachment('introducerQuestionnairesfile_4','gendralinformation_introducer_Questionnaires_file_4')">
                            <mat-icon>visibility</mat-icon>
                            </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (
                    this.formGroup.controls['introducerQuestionnairesfile_4'].invalid &&
                    (this.formGroup.controls['introducerQuestionnairesfile_4'].touched ||
                    this.formGroup.controls['introducerQuestionnairesfile_4'].dirty)
                    ) {
                    <mat-error>
                      @if (this.formGroup.controls['introducerQuestionnairesfile_4'].errors?.['required']
                      ) {
                      <span class="text-danger">{{ message }}</span>
                      } @else if (this.formGroup.controls['introducerQuestionnairesfile_4'].errors?.['invalidType']) {
                      <span class="text-danger">Only PDF, JPG or PNG files are allowed</span>
                      } @else if (this.formGroup.controls['introducerQuestionnairesfile_4'].errors?.['maxSize']) {
                      <span class="text-danger">File size must not exceed 5MB</span>
                      } @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                    }
                  </div>
                </li>

                <!-- Q5 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Do you or any of your connected persons* hold any directorship/ sole
                        proprietorship/ partnership/ other business interests in any entity in
                        Singapore or elsewhere which has business activities with PIAS?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_5')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true, 'introducerQuestionnaires_5', 5)"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_5')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false, 'introducerQuestionnaires_5', 5)"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_5')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_5')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If Yes, please specify the name of entities:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_5"
                          placeholder="Enter name of entities" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_5"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_5"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_5"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q6 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Do you or any of your connected persons have any shareholdings where 1% or
                        more of the shareholdings are held by them in any entity in Singapore or
                        elsewhere which has business activities with PIAS?</span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_6')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true, 'introducerQuestionnaires_6', 6)"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_6')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false, 'introducerQuestionnaires_6', 6)"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_6')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_6')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If Yes, please specify the name of entities:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_6"
                          placeholder="Enter name of entities" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_6"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_6"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_6"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q7 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Do you or any of your connected persons currently engaged in any gainful
                        employment (e.g. Contracting, Freelance, Consultancy work, Political position
                        or Second job) which has business activities with PIAS?</span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_7')?.value === true"
                        (change)="onCheckboxChange($event.checked, true, 'introducerQuestionnaires_7')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_7')?.value === false"
                        (change)="onCheckboxChange($event.checked, false, 'introducerQuestionnaires_7')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                  </div>
                  @if(questionError('introducerQuestionnaires_7')) {
                  <mat-error>
                    <p class="text-danger">{{message}}</p>
                  </mat-error>
                  }
                </li>

              </ol>
              <p class="note">
                * Connected persons – Spouse, civil partner, any person who lives with the director /
                employee as a partner in an enduring relationship (excluding grandparents,
                grandchildren, sister, brother, aunt, uncle, niece or nephew), children and
                stepchildren of any age, director's / employees' parents and children or step children
                of a person who lives with the director under the age of 18.
              </p>

              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn" (click)="onSectionSave('general')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Fit and Proper Criteria -->
          <mat-expansion-panel [expanded]="isPanelExpanded(4)" (opened)="onPanelOpened(4)" (closed)="onPanelClosed(4)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">verified_user</mat-icon>
                Fit and Proper Criteria
              </mat-panel-title>
              @if (getSectionStatus('fitproper') === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (getSectionStatus('fitproper') === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>
            <div class="check-list">
              <p class="note">
                If the answer to any of the following questions is in the affirmative, please attach
                annexes and supporting documents, where appropriate, to provide all relevant details.
                <br />Please complete the Sections below by furnishing information for the past 10
                years.
              </p>
              <h5 class="field-title">A. Honesty, Integrity and Reputation</h5>
              <ol class="custom-list">
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been licensed, registered or approved under any law in any
                        jurisdiction which requires licensing, registration or approval in relation to
                        any regulated activity per prescribed by Monetary Authority of Singapore?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_8')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_8')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_8')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_8')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_8')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_8')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, please provide the details:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_8"
                          placeholder="Enter schemes or company" />
                      </mat-form-field>
                      @if (questionError('introducerQuestionnairesyes_8')) {
                      <mat-error>{{ message }}</mat-error>
                      }
                    </div>
                    <div class="col-sm-10">
                      <span>If yes, have you been refused the right or restricted in your right in
                        relation to any regulated activity under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnairesop1_8')?.value === true"
                        (change)="onPairedCheckboxChange($event.checked, true, 'introducerQuestionnairesop1_8', 'introducerQuestionnairesop2_8')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnairesop2_8')?.value === false"
                        (change)="onPairedCheckboxChange($event.checked, false, 'introducerQuestionnairesop1_8', 'introducerQuestionnairesop2_8')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (pairedQuestionError('introducerQuestionnairesop1_8', 'introducerQuestionnairesop2_8')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been issued a prohibition order under any law in any jurisdiction or
                        have you been prohibited from operating in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_9')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_9')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_9')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_9')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_9')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been a shareholder of any corporation which holds membership of any
                        class or description of any operator of a market or clearing facility in any
                        jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_10')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_10')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_10')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_10')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_10')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been the subject of any complaint made reasonably and in good faith,
                        relating to any activities under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_11')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_11')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_11')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_11')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_11')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you ever been reported to the MAS pursuant to Financial Advisers Act
                        (FAA) Notice on Reporting of Misconduct of Representatives by Financial
                        Advisers, or equivalent provisions under Securities & Futures Act (SFA), or
                        any other Financial Services, Securities, Insurance or Banking Regulations?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_12')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_12')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_12')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_12')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_12')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been reported and/or issued Letter of Suspension/Warning/Advice by
                        your current or former employer(s) due to any misconducts or offences?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_13')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_13')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_13')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_13')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_13')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been the subject of any proceedings of a disciplinary or criminal
                        nature or have you been notified of any potential proceedings or of any
                        investigation which might lead to those proceedings, under any law in any
                        jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_14')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_14')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_14')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_14')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_14')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been convicted of any offence or are you being subject to any
                        pending proceedings which may lead to such a conviction, under any law in any
                        jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_15')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_15')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_15')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_15')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_15')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you had any judgment (in particular that associated with a finding of
                        fraud, misrepresentation or dishonesty) entered against you in any civil
                        proceedings or a party to any pending proceedings which may lead to such a
                        judgment, under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_16')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_16')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_16')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_16')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_16')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you accepted civil liability for fraud, misrepresentation or dishonesty
                        under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_17')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_17')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_17')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_17')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_17')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you had any civil penalty enforcement action taken against you by any
                        regulatory authority under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_18')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_18')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_18')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_18')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_18')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you contravened or abetted another party in breach of any laws or regulations, business
                        rules or codes of conduct, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_19')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_19')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_19')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_19')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_19')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been the subject of any investigations or disciplinary proceedings or been issued a
                        warning or reprimand by any regulatory authority, an operator of a market or clearing facility,
                        any professional body or government agency, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_20')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_20')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_20')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_20')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_20')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been refused a fidelity or surety bond, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_21')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_21')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_21')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_21')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_21')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you demonstrated an unwillingness to comply with any regulatory requirement or to
                        uphold
                        any professional and ethical standards, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_22')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_22')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_22')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_22')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_22')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been untruthful, provided false or misleading information or been uncooperative in
                        any dealings with any regulatory authority in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_23')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_23')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_23')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_23')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_23')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been a director, partner, substantial shareholder or concerned in the
                        management of a business that has been censured, disciplined, prosecuted or convicted of a
                        criminal offence, or been the subject of any disciplinary or criminal investigation or
                        proceeding,
                        in Singapore or elsewhere, in relation to any matter that took place while you were a director,
                        partner, substantial shareholder or concerned in the management of the business?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_24')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_24')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_24')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_24')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_24')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been a director, partner, substantial shareholder or concerned in the
                        management of a business that has been suspended or refused membership or registration by any
                        regulatory authority, an operator of a market or clearing facility, any professional body or
                        government agency, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_25')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_25')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_25')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_25')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_25')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been a director, partner, substantial shareholder or concerned in the management of
                        a
                        business that has gone into insolvency, liquidation or administration during the period when, or
                        within a period of one year after, you were a director, partner, substantial shareholder or
                        concerned in the management of the business, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_26')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_26')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_26')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_26')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_26')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been dismissed or asked to resign from office, employment, a position of trust or a
                        fiduciary appointment or similar position, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_27')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_27')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_27')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_27')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_27')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been subject to disciplinary proceedings by your current or former
                        employer(s), whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_28')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_28')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_28')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_28')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_28')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been disqualified from acting as a director or disqualified from acting in any
                        managerial capacity, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_29')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_29')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_29')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_29')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_29')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been an officer found liable for an offence committed by a body corporate as a
                        result
                        of the offence having proved to have been committed with the consent or connivance of, or
                        neglect
                        attributable to you, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_30')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_30')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_30')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_30')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_30')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you carrying on business in, or are you acting as a representative in respect of,
                        providing credit rating services?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_31')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_31')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_31')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_31')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_31')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_31')?.value === true) {

                    <div class="col-sm-10">
                      <span>If yes, are you or have you been in observance of the Code of Conduct for Credit Rating
                        Agencies.
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnairesop1_31')?.value === true"
                        (change)="onPairedCheckboxChange($event.checked, true, 'introducerQuestionnairesop1_31', 'introducerQuestionnairesop2_31')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnairesop2_31')?.value === false"
                        (change)="onPairedCheckboxChange($event.checked, false, 'introducerQuestionnairesop1_31', 'introducerQuestionnairesop2_31')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (pairedQuestionError('introducerQuestionnairesop1_31', 'introducerQuestionnairesop2_31')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    }
                  </div>
                </li>
                <h5 class="field-title">B. Financial Soundness</h5>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been unable to fulfil any of your financial obligations, whether in
                        Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_32')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_32')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_32')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_32')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_32')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been placed under the Debt Repayment Scheme (DRS), entered into a compromise or
                        scheme of arrangement with your creditors or made an assignment for the benefit of your
                        creditors,
                        being a compromise, scheme of arrangement or assignment that is still in operation, whether in
                        Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_33')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_33')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_33')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_33')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_33')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you subject to a judgment debt which is unsatisfied, either in whole or in part, whether
                        in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_34')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_34')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_34')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_34')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_34')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been the subject of a bankruptcy petition, whether in Singapore or
                        elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_35')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_35')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_35')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_35')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_35')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have you been adjudicated a bankrupt and the bankruptcy is undischarged, whether in
                        Singapore
                        or elsewhere
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_36')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_36')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_36')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_36')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_36')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are you or have you been a subject to any other process outside Singapore that is similar to
                        those referred to in Questions 28 to 30?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_37')?.value === true"
                        (change)="setCheckboxValue($event.checked, true, 'introducerQuestionnaires_37')"
                        [disabled]="isReadOnly()">Yes</mat-checkbox>
                      <mat-checkbox [checked]="formGroup.get('introducerQuestionnaires_37')?.value === false"
                        (change)="setCheckboxValue($event.checked, false, 'introducerQuestionnaires_37')"
                        [disabled]="isReadOnly()">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_37')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

              </ol>
              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn" (click)="onSectionSave('fitproper')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Additional Information -->
          <mat-expansion-panel [expanded]="isPanelExpanded(5)" (opened)="onPanelOpened(5)" (closed)="onPanelClosed(5)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                Additional Information
              </mat-panel-title>
              @if (sectionStatuses()['additional'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['additional'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>
            <p class="note">
              If the answer to any of the above questions is in the affirmative, please provide more information below.
            </p>
            <div class="col-md-12">
              <mat-form-field class="w-100 custom-form-field">
                <textarea id="adinput" matInput formControlName="additionalInfo"
                  placeholder="Enter Additional Information"></textarea>
              </mat-form-field>

              <!-- Other Attachments -->
              <div class="section-card other-attachments-card">
                <div class="section-header">
                  <mat-icon>attach_file</mat-icon>
                  <span>Other Attachments</span>
                </div>
                <div class="container-fluid">
                  <div class="row g-3">
                    @for(key of otherAttachmentKeys; track key){
                    <div class="col-md-6">
                      <div class="upload-container">
                        <div class="upload-box">
                          <input type="file" [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                            [disabled]="isReadOnly()"
                            (change)="onAttachmentFileChange($event, key + 'fileName', key, key)">
                          <input type="text" [formControlName]="key + 'fileName'" hidden>

                          <!-- Show filename OR placeholder -->
                          @if(!this.formGroup.get(key + 'fileName')?.value){
                          <span>
                            Choose file
                          </span>
                          }
                          @if(this.formGroup.get(key + 'fileName')?.value){
                          <div class="attachment-row">
                            <span class="file-name">
                              {{ this.formGroup.get(key + 'fileName')?.value }}
                            </span>
                            @if(isReadOnly() === false){
                            <button mat-icon-button color="primary" class="delete-btn"
                             (click)="removeFile(key + 'fileName', key, key)">
                            <mat-icon>close</mat-icon>
                            </button>
                            }
                           <button mat-icon-button color="primary" class="delete-btn"
                            (click)="previewAttachment(key + 'fileName', key)">
                            <mat-icon>visibility</mat-icon>
                            </button>
                          </div>
                          }
                        </div>
                        @if(isReadOnly() === false){
                        @if(!$first){
                        @if(!this.formGroup.get(key + 'fileName')?.value){  
                        <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                          matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                          <mat-icon>close</mat-icon>
                        </button>
                        }
                        }
                        @if($last){
                        <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                          matTooltip="Add another attachment" (click)="addOtherAttachment()">
                          <mat-icon>add</mat-icon>
                        </button>
                        }
                        }
                      </div>
                      @if(this.formGroup.get(key + 'fileName')?.invalid
                      && (this.formGroup.get(key + 'fileName')?.touched ||
                      this.formGroup.get(key + 'fileName')?.dirty)
                      ) {
                      <mat-error>
                        @if(this.formGroup.get(key + 'fileName')?.errors?.['invalidType']){
                        <span>Only PDF, JPG or PNG files are allowed</span>
                        }
                        @else if(this.formGroup.get(key + 'fileName')?.errors?.['maxSize']){
                        <span>File size must not exceed 5MB</span>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>

              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn" (click)="onSectionSave('additional')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Authorisation and Declaration -->
          <mat-expansion-panel [expanded]="isPanelExpanded(6)" (opened)="onPanelOpened(6)" (closed)="onPanelClosed(6)">

            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">how_to_reg</mat-icon>
                Authorisation and Declaration
              </mat-panel-title>
              @if (getSectionStatus('declaration') === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (getSectionStatus('declaration') === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="note">
              <h4 class="field-label">Important</h4>
              <ol>
                <li>
                  I declare that the information given in this application and in the attached annexes (if any) are true
                  and correct. I understand that any misrepresentation or omission of facts will be sufficient cause to
                  render my application void.
                </li>
                <li>
                  I understand that this application is subject to the acceptance and approval of PIAS, in which PIAS
                  has
                  the right to reject my application at their sole discretion without citing any reason.
                </li>
                <li>
                  I hereby give consent to PIAS for processing, collecting, using and disclosing my personal data to
                  Permitted Parties (as defined in PIAS' Personal Data Notice and Consent Policy) for the purpose of:
                  <ul>
                    <li>managing my introducer engagement and/or working relationship with PIAS (including payment of
                      commission);</li>
                    <li>forming part of PIAS' records as to the business carried on by PIAS;</li>
                    <li>observing any legal, governmental or regulatory requirements of any relevant jurisdiction
                      (including any disclosure or notification requirements to which PIAS is subject to);</li>
                    <li>carrying out due diligence, monitoring or other screening activities in accordance with PIAS'
                      legal or regulatory obligations or risk management procedures.</li>
                  </ul>
                </li>
              </ol>
            </div>
            <br>
            <div class="row">

              <mat-checkbox [checked]="formGroup.get('declarationaccepted')?.value === true"
                (change)="onDeclarationChange($event.checked)"
                [disabled]="formGroup.get('declarationaccepted')?.disabled">
                I agree to the above declaration
              </mat-checkbox>
              @if (
              this.formGroup.get('declarationaccepted')?.touched &&
              !isDeclarationAccepted()
              ) {
              <mat-error class="d-block">{{ message }}</mat-error>
              }

              <div class="col-md-6">
                <mat-label class="field-label">Name</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="declarationName" placeholder="Enter Name" readonly />
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Date</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input type="date" matInput formControlName="date" placeholder="Enter Date" readonly />
                </mat-form-field>
              </div>
              @if(isReadOnly() === false){
              <div class="form-actions mt-4 text-end">
                <button type="button" class="save-btn"
                  [disabled]="!(allSectionsCompletedExceptDeclaration() && isDeclarationAccepted())"
                  (click)="onFinalSubmit($event)">
                  <span>Submit</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }

            </div>

          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">

    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <!-- Header -->
      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="selectedDocument"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" class="preview-pdf"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }

</div>